/**
 * Sanitizes a card number by removing all non-digit characters.
 * This is necessary as the formatted input card may contain spaces, hyphens, or other formatting characters,
 * but the card number must be sent with only digits.
 *
 * @param {string|null|undefined} cardNumber - The card number to sanitize.
 * @returns {string} The sanitized card number containing only digits, or empty string if input is null/undefined.
 */
export default function sanitizeCardNumber(cardNumber) {
  return String(cardNumber || '').replace(/\D/g, '');
}
